import React, { useState, useEffect, useMemo } from "react"
import { Link } from "react-router-dom"
import axios from 'axios'
import Pagination from '../pages/paginations'

export const CsrCatalog = ({ showStats }) => {
    const [summary, setSummary] = useState({
        totalNilai: 0,
        totalProyek: 0,
        proyekTersedia: 0,
        proyekSelesai: 0
    })
    const [klaster, setKlaster] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize, setPageSize] = useState(4)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchSummary = async () => {
            try {
                const res = await axios.get("/api/csr/portal/summary")
                if (res.data.summary) setSummary(res.data.summary)
                setKlaster(res.data.perKlaster || [])
                setLoading(false)
            } catch (err) {
                console.error("Gagal load summary", err)
                setLoading(false)
            }
        }
        fetchSummary()
    }, [])

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            const res = await axios.get("/api/csr/portal/cluster")
            if (res.data) setData(res.data)
            setLoading(false)
        } catch (err) {
            console.error("Gagal load data", err)
            setLoading(false)
        }
    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setPageSize(1)
            } else {
                setPageSize(4)
            }
        }

        handleResize()

        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        setCurrentPage(1)
    }, [PageSize])

    const allClusters = useMemo(() => {
        const groups = data.reduce((acc, item) => {
            const key = item.klaster
            if (!acc[key]) {
                acc[key] = {
                    name: key,
                    total: 0,
                    tersedia: 0,
                    diambil: 0,
                    selesai: 0
                }
            }
            acc[key].total++
            if (item.status === "Tersedia") acc[key].tersedia++
            if (item.status === "Diambil") acc[key].diambil++
            if (item.status === "Selesai") acc[key].selesai++
            return acc
        }, {})
        return Object.values(groups)
    }, [data])

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !allClusters ? [] : allClusters.slice(firstPageIndex, lastPageIndex)
    }, [allClusters, currentPage, PageSize])

    if (loading) return null

    return (<>
        {showStats && (
            <header id="csr-section" className="ms-hero-page-override ms-bg-fixed no-mt pb-1">
                <div className="container">
                    <div className="row no-shadow mt-2">
                        <div className="col-lg-12">
                            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <h3 className="no-m">Sinergi Kemitraan</h3>
                                <h1 className="color-success font-bold no-mt">Peta Kontribusi Tanggung Jawab Sosial Lingkungan (TJSL/CSR)</h1>
                                {/* <Link to="/laporan/realisasi-tjsl" className="btn btn-primary btn-raised btn-sm br-2 no-m">
                                    Lihat Laporan Detail <i className="zmdi zmdi-chart-donut ml-1"></i>
                                </Link> */}
                            </div>

                            {/* <div className="row">

                                <div className="col-lg-6 col-md-6">
                                    <div className="card card-stats animated fadeInUp br-2">
                                        <div className="card-body p-3">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-3 text-center">
                                                    <div className="bg-success shadow-2dp" style={{ width: '60px', height: '60px', borderRadius: '50%', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className="zmdi zmdi-money-box" style={{ fontSize: '32px', color: '#fff' }}></i>
                                                    </div>
                                                </div>
                                                <div className="col-9 text-right">
                                                    <p className="no-m" style={{ fontSize: '14px' }}>Total Komitmen Investasi</p>
                                                    <h2 className="color-success font-bold no-m" style={{ fontSize: '24px' }}>
                                                        Rp {summary.totalNilai.toLocaleString('id-ID')}
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer p-1 bg-success text-center border-bottom-radius-2">
                                            <small className="color-white">Berdasarkan TJSL/CSR Tersedia & Terlaksana</small>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="card card-stats animated fadeInUp animation-delay-3 br-2">
                                        <div className="card-body p-3">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-3 text-center">
                                                    <div className="bg-primary shadow-2dp" style={{ width: '60px', height: '60px', borderRadius: '50%', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className="zmdi zmdi-assignment-check" style={{ fontSize: '32px', color: '#fff' }}></i>
                                                    </div>
                                                </div>
                                                <div className="col-9 text-right">
                                                    <p className="no-m" style={{ fontSize: '14px' }}>Akumulasi TJSL/CSR</p>
                                                    <h2 className="color-primary font-bold no-m" style={{ fontSize: '24px' }}>
                                                        {summary.totalProyek} Kegiatan
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer p-1 bg-primary text-center border-bottom-radius-2">
                                            <small className="color-white">{summary.proyekSelesai} Selesai | {summary.proyekTersedia} Menunggu Mitra</small>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="row fail">
                                {tableData.map((val, index) =>
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-12" key={index}>
                                        <div className="card animated zoomInUp br-2 shadow-2dp" style={{ marginTop: '20px' }}>

                                            {/* Bagian Atas: Nama Klaster */}
                                            <div className="text-center" style={{ padding: '25px 10px 15px 10px', background: '#f8f9fa', borderBottom: '1px solid #eee' }}>
                                                <h4 className="font-bold color-success no-m text-center" style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {val.name.toUpperCase()}
                                                </h4>
                                            </div>

                                            <div className="card-body">
                                                <div className="text-center mb-3">
                                                    {/* <h3 className="font-bold no-m color-dark">{val.total}</h3> */}
                                                    {/* <small className="text-muted" style={{ letterSpacing: '1px' }}>TOTAL TJSL/CSR</small> */}
                                                    <h3 className="font-bold no-m color-dark">{val.tersedia}</h3>
                                                    <small className="text-muted" style={{ letterSpacing: '1px' }}>TJSL/CSR TERSEDIA</small>
                                                </div>

                                                {/* <hr className="mt-2 mb-3" />

                                                <div className="row text-center no-gutters">
                                                    <div className="col-4">
                                                        <h4 className="no-m font-bold color-success">{val.tersedia}</h4>
                                                        <small style={{ fontSize: '8px', display: 'block', fontWeight: '800' }}>TERSEDIA</small>
                                                    </div>
                                                    <div className="col-4" style={{ borderLeft: '1px solid #eee', borderRight: '1px solid #eee' }}>
                                                        <h4 className="no-m font-bold color-warning">{val.diambil}</h4>
                                                        <small style={{ fontSize: '8px', display: 'block', fontWeight: '800' }}>PROSES</small>
                                                    </div>
                                                    <div className="col-4">
                                                        <h4 className="no-m font-bold color-primary">{val.selesai}</h4>
                                                        <small style={{ fontSize: '8px', display: 'block', fontWeight: '800' }}>SELESAI</small>
                                                    </div>
                                                </div> */}
                                            </div>

                                            <div className="card-footer text-right border-bottom-20">
                                                <Link to={`/csr-katalog/${val.name.toLowerCase().replaceAll(' ', '-')}`}>Telusuri <i className="ml-1 no-mr zmdi zmdi-long-arrow-right"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="text-center p-4">
                                <Pagination
                                    className="pagination-bar"
                                    currentPage={currentPage}
                                    totalCount={allClusters.length}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )}
    </>)
}